// Generated by CoffeeScript 1.6.3
/*
jQuery observe
Copyright 2013 Kevin Sylvestre
1.0.5
*/


(function() {
  "use strict";
  var $, Observer;

  $ = jQuery;

  Observer = (function() {
    Observer.settings = {
      interval: 700
    };

    function Observer(input, callback, settings) {
      if (settings == null) {
        settings = {};
      }
      this.input = input;
      this.callback = callback;
      this.settings = $.extend({}, Observer.settings, settings);
      this.observe();
    }

    Observer.prototype.observe = function() {
      var _this = this;
      $(this.input).bind("keyup paste search", function() {
        return _this.modified = new Date();
      });
      return this.every(this.settings.interval, function() {
        if (_this.modified != null && (new Date().getTime() - _this.modified.getTime()) >= _this.settings.interval) {
          _this.callback.call(_this.input);
          return delete _this.modified;
        }
      });
    };

    Observer.prototype.every = function(interval, callback) {
      return setInterval(callback, interval);
    };

    return Observer;

  })();

  $.fn.extend({
    observe: function(callback, options) {
      if (options == null) {
        options = {};
      }
      return this.each(function() {
        return new Observer(this, callback, options);
      });
    }
  });

}).call(this);
